<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
import Select from "@/components/c-select";
import Loading from "@/components/c-loading";
import { stockjournalService } from "../../../services/financeservice/stockjournal.service";
import { stockownerService } from "../../../services/financeservice/stockowner.service";
import { servicehelpers } from "../../../services/servicehelpers";
import i18n from "../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Journal Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Area,
    Select, 
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      stockOwnerJournal: {},
      stockOwnerSummaryDataList: {},
      projectDataList: {},
      accounttDataList: {},
      paymentMethodData: {},
      bankAccountData: {},
      valueProject: 0,
      valueDate: this.$moment().clone().format('YYYY-MM-DD'),
      valueInvestment: 0,
      valueNotation: '',
      valueEntries: [],
      valueType: 0,
      valueName: '',
      valueCode: '',
      valueAccount: 0,
      valueBankAccount: 0,
      valuePaymentMethod: 1
      
    };
  },
  mounted() {
    this.loadingAccountData();
    this.loadingProjectData();

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else {
       this.loadingData(0);
    }
  },

  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      stockjournalService.getOne(id)
        .then(response => {

          this.fetchingStats = true;
          if(response.data) {
            this.breadCrumb = {
              text: response.data.name + " - (" + response.data.code + ")",
              active: true,
            };

            this.stockOwnerJournal = response;

            if(this.stockOwnerJournal.data.stock_owner_journal_status_id != 1) {
              this.$swal.fire({
                title: i18n.t('stock-owner.invalid-edit.title'),
                text: i18n.t('stock-owner.invalid-edit.message'),
                icon: "success",
                confirmButtonText: i18n.t('general.ok')
              });

              this.$router.push(this.$route.query.redirectFrom || {
                name: "stock-owner-list"
              });
            }

            // console.log(JSON.stringify(this.stockOwnerJournal));

            this.valueProject = this.stockOwnerJournal.data.project_id;
            this.valueDate = this.stockOwnerJournal.data.invest_date;
            this.valueInvestment = this.stockOwnerJournal.data.invest_amount;
            this.valueNotation = this.stockOwnerJournal.data.notation;
            this.valueType = this.stockOwnerJournal.data.type_id == 1 ? 0 : 1;
            this.valueCode = this.stockOwnerJournal.data.code;
            this.valueName = this.stockOwnerJournal.data.name;
            this.valueAccount = this.stockOwnerJournal.account_id;

            this.stockOwnerJournal.data.collections.map(item => {
              if('stock_owner_journal_entries' in item) {
                this.valueEntries = item.stock_owner_journal_entries;
              }
            });
          } 

          this.loadingSettings(response.setting);

          // console.log(JSON.stringify(this.stockOwnerJournal.data));
          // console.log(this.valueType);
          
        });
    },

    loadingProjectData: function() {
      servicehelpers.getProjectData().then(response => {
        this.projectDataList = response;
      });
    },

    loadingAccountData: function(type = 12) {
      servicehelpers.getAccountData(type).then(response => {
        this.accounttDataList = response;

        // console.log(JSON.stringify(this.accounttDataList.data));
      });
    },

    loadingShareHolder: function(projectId) {
      let param = `?page=0&clause={"clause":[{"conjuction":"and","stock_owner_summaries.project_id":{"value":${projectId}}}]}`;
      stockownerService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.stockOwnerSummaryDataList = response.data;

        });
    },

    projectChanged: function(event) {
      this.loadingShareHolder(event);
    },
    
    paymentMethodChanged: function(event) {

      if(event != 2 && event != 3) {
        this.valueBankAccount = 0;
      }
    }, 

    loadingSettings: function(setting) {

      // this.customerData = {data: setting.customers};
      // this.projectData = {data: setting.projects};
      // this.propertyData = {data: setting.properties};
      // this.paymenttermData  = {data: setting.paymentterms};
      // this.commissionTypeData = {data: setting.commissiontypes};
      // this.templeteData = {data: setting.templates.filter((item) => item.contract_type_id == 3)};
      this.paymentMethodData = {data: setting.paymentmethods};
      this.bankAccountData = {data: setting.bankaccounts};

      // console.log(setting);
    },

    submitCancel: function() {

      // console.log(this.dataType);

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "customer-list"
          });

        }
      });
      
    },
    submitSave: function() {

      this.tryingToSubmit = true;
      let entries = [];

      

      if(!this.valueEntries.length) {

        this.stockOwnerSummaryDataList.map((item) => {
          entries.push({
            project_owner_id: item.project_owner_id,
            share: item.share,
            invest_share: this.valueInvestment * item.share / 100,
            notation: ""
          });
        });
      } else {
        this.valueEntries.map((item) => {
          entries.push({
            id: item.id,
            project_owner_id: item.project_owner_id,
            share: item.share,
            invest_share: this.valueInvestment * item.share / 100,
            notation: ""
          });
        });
      }

      let journal = {
        project_id: this.valueProject,
        invest_date: this.valueDate,
        invest_amount: this.valueInvestment,
        notation: this.valueNotation,
        type_id: this.valueType == 1 ? 2 : 1,
        code: this.valueCode,
        name: this.valueName,
        stock_owner_journal_status_id: 1,
        stock_owner_journal_entries: entries,
        account_id: this.valueAccount,
        payment_method_id: this.valuePaymentMethod,
        bank_account_id: this.valueBankAccount 

      };

      // console.log(JSON.stringify(customer));

      if(this.isAdd) {
        stockjournalService.insert(journal)
         .then(response => {
           this.tryingToSubmit = false;

           if(response.status == 200) {
              this.clearForm();
              this.$swal.fire({
                title: i18n.t('general.success.title'),
                text: i18n.t('general.success.message'),
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: i18n.t('general.success.yes'),
                cancelButtonText: i18n.t('general.success.no')
              }).then(result => {
                if (!result.value) {
                  this.$router.push(this.$route.query.redirectFrom || {
                    name: "stock-owner-list"
                  });
                } 
              });
           }
          
        });
      } else {
        // console.log(JSON.stringify(customer));
        stockjournalService.update(this.$route.params.id, journal)
         .then(response => {
          this.tryingToSubmit = false;

          if(response.status == 200) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "stock-owner-list"
            });

            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message-edit'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
      }
    },

    clearForm: function() {
      this.valueProject = 0;
      this.valueDate = this.$moment().clone().format('YYYY-MM-DD'),
      this.valueInvestment = 0;
      this.valueNotation = '';
      this.valueType = 1;
      this.valueName = '';
      this.valueCode = '';
      this.valueAccount = 0;
      this.valueBankAccount = 0;
      this.valuePaymentMethod = 1;
      
    }, 

  }
};
</script>

<template>
  <Layout>

      <PageHeader :items="[{
        text: $t('stock-owner.journal'),
        href: '/finance/stock',
      }, {
        text: $t('stock-owner.journal'),
        active: true
      }]" :title="$t('stock-owner.journal')" />

   

    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
              <div class="row">
                <div class="col-lg-6">
                  <Select 
                :text="'name'"
                    @change="projectChanged"
                    :id="'sex'"
                    :text2="'name_en'"
                    v-model="valueProject"
                    :list="this.projectDataList"
                    :label="'property.project'"  />
                </div>
                <div class="col-lg-6">
                  <Input 
                    :type="'date'"
                    :id="'invest_date'"
                    v-model="valueDate"
                    :label="'stock-owner.date'"  />
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <Input 
                    :type="'text'"
                    :id="'code'"
                    v-model="valueCode"
                    :label="'stock-owner.code'"  />
                </div>
                <div class="col-lg-6">
                  <Input 
                    :type="'text'"
                    :id="'name'"
                    v-model="valueName"
                    :label="'stock-owner.name'"  />
                </div>
              </div>
              <div class="row">
                
                <div class="col-md-6">
                  <Input 
                    :type="'number'"
                    :id="'invest_amount'"
                    v-model="valueInvestment"
                    :last="'USD'"
                    :label="'stock-owner.investment'"  />
                </div>
                <div class="col-md-2">
                  <div class="form-check form-switch form-switch-md mb-3" style="margin-top: 33px;">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="type_id"
                      :disabled="!isAdd"
                      v-model="valueType"
                    />
                    <label class="form-check-label" for="type_id"
                      >{{$t('stock-owner.withdrawal')}}</label
                    >
                  </div>
                </div>
                <div class="col-lg-4">
                  <Select 
                    :text="'name'"
                    :id="'account'"
                    v-model="valueAccount"
                    :list="this.accounttDataList"
                    :label="'stock-owner.account'"  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <Select
                    @change="paymentMethodChanged" 
                    :id="'payment_method_id'"
                    :auto="true"
                    v-model="valuePaymentMethod"
                    :list="this.paymentMethodData"
                    :label="'booking.payment-method'"
                     /> 
                </div>
                <div v-show="valuePaymentMethod == 2 || valuePaymentMethod == 3" class="col-md-6">
                  <Select
                    :id="'bank_account_id'"
                    v-model="valueBankAccount"
                    :list="this.bankAccountData"
                    :label="'payment.bank_account'"
                     /> 
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <Area 
                    :rows="5"
                    :id="'address'"
                    v-model="valueNotation"
                    :label="'stock-owner.notation'"  />
                </div>
              </div>
              

              <div class="row">
                <div class="col-lg-12">

                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </div>
    
                </div>
              </div>
          
          </div>
        </div>
      </div>
    </b-form> 
  
  </Layout>
</template>